export default "__VITE_ASSET__DlZUJ3KO__"